import React from 'react';
import {Grid, Typography} from "@mui/material";

export type DescriptionsProps = {
    title?: string;
    children: Array<React.ReactNode>;
    column?: number;
};

const Descriptions: React.FC<DescriptionsProps> = (props) => {
    const xs = props.column ? (12 / props.column) : 4;
    return (
        <div>
            <Typography variant={'h6'}>{props.title}</Typography>
            <Grid container spacing={2}>
                {props.children && props.children.map((child, index) => {
                        if (child != null) {
                            return <Grid key={index} item xs={xs}>
                                {child}
                            </Grid>
                        }
                        return null;
                    }
                )}
            </Grid>
        </div>
    );
};
export default Descriptions;